<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：栏目导航</div>
      </div>
      <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div :class="[textobj.isSpecial == 0 ? 'red' : 'title']">
        {{ textobj.titleContent }}
      </div>
      <div class="line"></div>
      <div class="info">
        <span>作者：{{ textobj.author }}</span>
        <span style="margin: 0 7px">出处：{{ textobj.source }}</span>
        <span>时间：{{ textobj.createTime }}</span>
      </div>
      <div class="browse">
        <!-- <div class="count">
          浏览次数：<span style="font-size: 20px; color: #2e5bb6">{{
            count
          }}</span>
        </div> -->
      </div>
      <div class="news-content">
        <div v-html="textobj.content"></div>
      </div>
      <div v-if="textobj.fileUrl" class="dolongw">
        <div class="dolong">
          <div class="file">
            <div class="image">
              
              <img src="../../../../assets/images/file.png" class="ims" alt="">
            </div>
            <div>
              <span class="title">{{ textobj.fileUrl.slice(51) }}</span>
            </div>
          </div>
          <div class="dowl hover-underline" @click="download">
            <img src="../../../../assets/images/download.png" class="ims" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { infospecial } from "@/api/columnWindow";
export default {
  data() {
    return {
      title: "安徽六市纪委监委通报！",
      author: "池州支队",
      from: "池州支队网",
      date: "2024-10-08",
      count: 10,
      tableList:[],
      textobj:{},
    }
  },
  props: ["ids","winTitle"],
  mounted() {
    // this.ids = Number(this.ids);
    this.getlistInfo();
  },
  methods: {
    getlistInfo() {
      infospecial(this.ids).then(res => {
        this.textobj = res.data.data;
      })
      // queryListspecial({ pageNum: 1, pageSize: 999 }).then((res) => {
      //   this.tableList = res.data.data.list;
      //   this.textobj = this.tableList.find((item) => {
      //     return item.id == this.ids;
      //   });
      // });
    },
    returnshow() {
      this.$emit("setCilck");
    },
    download(){
      window.open(this.textobj.fileUrl)
    }
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #f0f5ff;
  margin-bottom: 60px;
}

.nav-tab {
  width: 100%;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
.dolongw{
  width: 100%;
  padding: 40px;
  .dolong {
    display: flex;
    justify-content: space-between;
    width:  calc(100% - 80px);
    height: 40px;
    line-height: 35px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #F5F5F5;
    padding-left: 20px;
    .dowl {
      width: 34px;
      .ims {
          width: 12px;
          height: 14px;
          vertical-align:middle;
        }
    }
    .file {
      display: flex;
      .image {
        display: inline-block;
        height: 40px;
        .ims {
          width: 12px;
          height: 14px;
          vertical-align:middle;
        }
     }
     .title {
      margin-left: 8px;
      font-size: 14px;
      color: #999999;
     }
    }
  }
  
}

.content {
  width: 1120px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 60px;

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    margin-bottom: 16px;
  }

  .line {
    width: 1040px;
    height: 2px;
    margin: 0 auto;
    margin-bottom: 16px;
    background: #2e5bb6;
  }

  .info {
    text-align: center;
  }

  .browse {
    width: 1040px;
    height: 40px;
    margin: 0 auto;
    font-size: 14px;
    color: #333333;
    position: relative;

    .count {
      position: absolute;
      right: 0;
    }
  }

  .img-box {
    width: 510px;
    height: 340px;
    margin: 0 auto;
    margin-bottom: 20px;
    img {
      width: 510px;
      height: 340px;
    }
  }
  .news-content {
    width: 1040px;
    margin: 0 auto;
    text-indent: 2em;
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.red {
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 16px;
  color: #e71111;
}
</style>
